<template>
  <div class="bookIndex">
    <h2 class="sr-only">樹木小百科</h2>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "BookIndex"
};
</script>
<style lang="scss" scoped>
.bookIndex {
  height: inherit;
}
</style>
